import { CommonModule } from '@angular/common';
import { Component, OnInit, TemplateRef, ViewChild, OnDestroy, AfterViewInit, Pipe } from '@angular/core';
import { MatTableModule } from '@angular/material/table';
import { MatCheckboxChange, MatCheckbox } from "@angular/material/checkbox";
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { Subject } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { merge, of as observableOf } from 'rxjs';
import { catchError, map, startWith, switchMap, takeUntil } from 'rxjs/operators';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { DatePipe } from '@angular/common';

import { CoreService } from '../../../services/core.service';
import { SocialAICommercialModelI } from '../../../interfaces/core.interface';
import { DialogComponent } from '../../dialog/dialog.component';
import { CommercialPlanFormComponent } from '../../forms/create-account/commercial-plan-form/commercial-plan-form.component';


@Component({
  selector: 'app-social-publisher-commercial-model-table',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatTableModule,
    MatSortModule,
    MatPaginator,
    MatIcon,
    MatCheckbox,
    MatToolbarModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    MatDatepickerModule,
    CommercialPlanFormComponent
  ],
  providers: [DatePipe],
  templateUrl: './social-publisher-commercial-model-table.component.component.html',
  styleUrl: './social-publisher-commercial-model-table.component.component.scss'
})
export class SocialSocialAIPlanTableComponentComponent implements OnInit, AfterViewInit {
  @ViewChild('publisherCommercialModelFormTmpl', { static: true }) publisherCommercialModelFormTmpl!: TemplateRef<any>;
  @ViewChild('confirmDeleteTmpl', { static: true }) confirmDeleteTmpl!: TemplateRef<any>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  selectedSocialAIPlan: SocialAICommercialModelI = {} as SocialAICommercialModelI;
  selectOptions: any = [];
  originalColumns: string[] = [];
  dataSource = new MatTableDataSource<SocialAICommercialModelI>();
  displayedColumns: string[] = [
    'ID',
    'Name',
    'start_date',
    'Description',
    'updated_at',
    'monthyear',
    'PricingPlan',
    'price',
    'discount',
    'finalprice',
    'delete'
  ];
  showFilters: boolean = false;
  conditions = {
    Name: '',
    start_date: '',
    Description: '',
    MinimumMonthlyPayment: '',
    MaximumMonthlyPayment: '',
    ArticleCost: '',
  };

  loading: boolean = false;
  totalItems: number = 0;
  companyID!: number;

  private destroy$ = new Subject<void>();

  constructor(
    private coreService: CoreService,
    private datePipe: DatePipe,
    public dialog: MatDialog,
  ) { this.originalColumns = [...this.displayedColumns]; }

  buildQueryParams(): any {
    return {
      ...this.conditions,
      sortBy: this.sort?.active || '',
      sortOrder: this.sort?.direction || '',
      offset: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize
    };
  }

  ngOnInit(): void {

  this.coreService.getData(`/company/dropdown`).subscribe(data => {
    this.selectOptions = data
  });

  const divContent = document.getElementById('companysettingsfor')?.innerHTML;

  if (divContent) {
    this.companyID = Number(divContent);
  }

}

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => (this.paginator.pageIndex = 0));
    const divContent = document.getElementById('companysettingsfor')?.innerHTML;
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({}),
        switchMap(() => {
          const params = this.buildQueryParams();
          return this.coreService.getData(`/socialaicommercialmodel/${divContent}`, params)
            .pipe(catchError(() => observableOf(null)));
        }),
        map(data => {
          this.loading = false;
          return data;
        }),
        takeUntil(this.destroy$)
      )
      .subscribe(data => {
        this.dataSource = data.data;
        this.totalItems = data.total;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  toggleColumnVisibility(event: MatCheckboxChange, column: string) {
    if (event.checked) {
      // Add the column back in the correct order
      const index = this.originalColumns.indexOf(column);
      if (index !== -1) {
        this.displayedColumns.splice(index, 0, column);
      }
    } else {
      // Remove the column
      this.displayedColumns = this.displayedColumns.filter((col) => col !== column);
    }
  }

  addNewSocialAIPlan() {
    this.selectedSocialAIPlan = {} as SocialAICommercialModelI;

    const companyID = document.getElementById('companysettingsfor')?.innerHTML;

    this.dialog.open(DialogComponent, {
      data: {
        content: this.publisherCommercialModelFormTmpl,
        header: 'Add New Publio Plan',
        cls: '!bg-slate-600 !text-white',
        formData: {},
        companyID: companyID
      },
      width: '500px',
      maxWidth: '500px'
    });
  }

  editSocialAIPlan(row: SocialAICommercialModelI) {
    this.selectedSocialAIPlan = row;

    const companyID = document.getElementById('companysettingsfor')?.innerHTML;

    this.dialog.open(DialogComponent, {
      data: {
        content: this.publisherCommercialModelFormTmpl,
        header: 'Edit Social AI Plan',
        cls: '!bg-slate-600 !text-white',
        formData: row,
        companyID: this.companyID
      },
      width: '500px',
      maxWidth: '500px'
    });
  }

  openDeleteSocialAIPlan(row: SocialAICommercialModelI) {
    this.selectedSocialAIPlan = row;
    this.dialog.open(DialogComponent, {
      data: {
        content: this.confirmDeleteTmpl,
        header: 'Delete Social AI Plan?',
        cls: 'bg-red-500 !text-white'
      }
    });
  }

  deleteSocialAIPlan(): void {
    this.coreService.deleteData('socialaicommercialmodel/destroy', String(this.selectedSocialAIPlan.ID)).subscribe(() => {
      this.onSubmitSocialAIPlanClbk();
    });
  }

  onSubmitSocialAIPlanClbk() {
    this.dialog.closeAll();
    const divContent = document.getElementById('companysettingsfor')?.innerHTML;
    const offset = (this.paginator.pageIndex ?? 0) * this.paginator.pageSize;
    this.coreService.getData(`/socialaicommercialmodel/${divContent}`, {
      offset: Number(offset),
      limit: this.paginator.pageSize,
      sortBy: this.sort.active ?? '',
      sortOrder: this.sort.direction ?? ''
    }).subscribe(data => {
      this.dataSource = data.data;
      this.totalItems = data.total;
    })
  }

  /** FILTERS ********************************************************************** */

  clearConditions() {
    this.conditions = {
      Name: '',
      start_date: '',
      Description: '',
      MinimumMonthlyPayment: '',
      MaximumMonthlyPayment: '',
      ArticleCost: '',
    };
  }

  applyConditions() {
    this.paginator.pageIndex = 0;

    const params = {
      ...this.conditions,
      start_date: this.datePipe.transform(this.conditions.start_date, 'd/M/y') ?? '',
      sortBy: Boolean(this.sort.active) ? this.sort.active : "",
      sortOrder: this.sort.direction ?? "",
      limit: this.paginator.pageSize,
      offset: 0,
    };

    this.paginator.pageIndex = 0;
    this.sort.sortChange.emit();
  }
}
